export default __webpack_public_path__ + "static/media/05.01ff445e.webp";